import DriverInvoiceTemplate from './DriverInvoiceTemplate.view'

export default DriverInvoiceTemplate;
